import { Minus, Plus } from 'lucide-react';
import { Input } from '../../components/ui/input';

export const lineResult = (expected, delivered) =>
  delivered === expected ? 'match' : delivered > expected ? 'over' : delivered === 0 ? 'missing' : 'short';

const BADGE = {
  match: 'bg-emerald-500/15 text-emerald-600', short: 'bg-amber-500/15 text-amber-600',
  over: 'bg-sky-500/15 text-sky-600', missing: 'bg-destructive/15 text-destructive',
};

export default function ReceivingLineCard({ item, line, onChange, highlight }) {
  const delivered = parseInt(line.delivered, 10) || 0;
  const result = lineResult(item.outstanding, delivered);
  const set = (k) => (e) => onChange({ ...line, [k]: e.target.value });
  const pid = item.product_id;
  return (
    <div id={`po-line-${pid}`} data-testid={`staff-app-po-line-${pid}`}
      className={`rounded-xl border bg-card p-3 space-y-2.5 transition-colors duration-500 ${highlight ? 'border-primary ring-2 ring-primary/30' : 'border-border'}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-sm font-semibold truncate">{item.product_name}</p>
          <p className="text-xs text-muted-foreground">Expected {item.outstanding}{item.quantity_received ? ` (of ${item.quantity_ordered}, ${item.quantity_received} already in)` : ''}</p>
        </div>
        <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded shrink-0 ${BADGE[result]}`} data-testid={`staff-app-po-line-result-${pid}`}>{result}</span>
      </div>
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => onChange({ ...line, delivered: Math.max(0, delivered - 1) })} className="h-10 w-10 rounded-md border border-border flex items-center justify-center" data-testid={`staff-app-po-line-minus-${pid}`}><Minus className="w-4 h-4" /></button>
        <Input type="number" min="0" inputMode="numeric" value={line.delivered} onChange={set('delivered')} className="h-10 text-center font-bold" data-testid={`staff-app-po-line-qty-${pid}`} />
        <button type="button" onClick={() => onChange({ ...line, delivered: delivered + 1 })} className="h-10 w-10 rounded-md border border-border flex items-center justify-center" data-testid={`staff-app-po-line-plus-${pid}`}><Plus className="w-4 h-4" /></button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <Input value={line.batch_number} onChange={set('batch_number')} placeholder="Batch no." className="h-9 text-xs" data-testid={`staff-app-po-line-batch-${pid}`} />
        <Input type="date" value={line.expiry_date} onChange={set('expiry_date')} className="h-9 text-xs" aria-label="Expiry date" data-testid={`staff-app-po-line-expiry-${pid}`} />
        <Input type="number" min="0" inputMode="numeric" value={line.damaged} onChange={set('damaged')} placeholder="Damaged" className="h-9 text-xs" aria-label="Damaged quantity" data-testid={`staff-app-po-line-damaged-${pid}`} />
      </div>
    </div>
  );
}
